function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.921 10.328c-.417.33-1.01.348-1.448.044l-1.389-.963a.962.962 0 00-1.213.098.833.833 0 00-.054 1.145l2.25 2.635a1.627 1.627 0 002.383.077l5.71-5.847a.78.78 0 00-.015-1.11.903.903 0 00-1.183-.06l-5.04 3.98z",
  fill: "#3C7C45"
});

var SvgCircleCheckCheckedBig = function SvgCircleCheckCheckedBig(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z' fill='currentColor' /%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.92111 10.3279C8.5035 10.6577 7.91083 10.6757 7.47281 10.372L6.08433 9.40916C5.70966 9.14935 5.19678 9.19082 4.87139 9.50724C4.55195 9.81787 4.52838 10.314 4.81701 10.6519L7.06731 13.2867C7.10747 13.3337 7.15045 13.3784 7.19604 13.4205C7.83466 14.0101 8.84393 13.9847 9.45031 13.3637L15.1596 7.51662C15.4651 7.20377 15.4585 6.71119 15.1448 6.40614C14.8245 6.09463 14.3138 6.06896 13.9621 6.3467L8.92111 10.3279Z' fill='%233C7C45'/%3E %3C/svg%3E";
export { SvgCircleCheckCheckedBig as ReactComponent };